import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Sobre", href: "#sobre" },
    { label: "Como Funciona", href: "#como-funciona" },
    { label: "Serviços", href: "#servicos" },
    { label: "Depoimentos", href: "#depoimentos" },
    { label: "Contato", href: "#contato" },
  ];

  const scrollTo = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 py-3 md:py-4 flex items-center justify-between">
        {/* Logo — left aligned, proper navbar size */}
        <h1 className="flex-shrink-0 ml-0 md:ml-10">
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); scrollTo("#hero"); }}
            className="cursor-pointer block"
          >
            <img
              src="https://static.readdy.ai/image/61892072331720d5ae52870a50f3ccd8/df0d25b7383130e226bb00168de2225d.png"
              alt="Primor Odontologia e Saúde Integrada"
              className="h-16 md:h-40 w-auto object-contain"
            />
          </a>
        </h1>

        {/* Nav links — center */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? "text-primary-700 hover:text-secondary"
                    : "text-white hover:text-secondary-300"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA — right */}
        <a
          href="https://wa.me/5511999999999"
          target="_blank"
          rel="nofollow noreferrer"
          className="hidden md:flex items-center gap-2 bg-secondary hover:bg-secondary-500 text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
        >
          <i className="ri-whatsapp-line text-base"></i>
          WhatsApp
        </a>

        {/* Mobile toggle */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`md:hidden text-2xl cursor-pointer ${
            scrolled ? "text-primary-700" : "text-white"
          }`}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4">
          <ul className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                  className="text-primary-700 font-semibold text-sm cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="https://wa.me/5511999999999"
            target="_blank"
            rel="nofollow noreferrer"
            className="mt-4 flex items-center gap-2 bg-secondary text-white px-5 py-2.5 rounded-full text-sm font-semibold w-fit cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line"></i>
            WhatsApp
          </a>
        </div>
      )}
    </nav>
  );
}
